import { render, staticRenderFns } from "./MessageDetails.vue?vue&type=template&id=17ce49dc&scoped=true&"
import script from "./MessageDetails.vue?vue&type=script&lang=js&"
export * from "./MessageDetails.vue?vue&type=script&lang=js&"
import style0 from "./MessageDetails.vue?vue&type=style&index=0&id=17ce49dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ce49dc",
  null
  
)

export default component.exports